<template>
    <form class="card">
        <h3>Текущая загруженность</h3>
        <div class="inline">
            <div class="buttons-group inline">
                <div class="buttons-group-item" v-for="(item, key) in daysList" :key="key">
                    <input type="radio" :id="'day' + key" v-model="day" :value="key" @change="getData()" />
                    <label :for="'day' + key">{{ item }}</label>
                </div>
            </div>
            <div class="buttons-group inline">
                <div class="buttons-group-item" v-for="(item, key) in garageList" :key="key">
                    <input type="radio" :id="'garage' + key" v-model="garage" :value="key" @change="getData()" />
                    <label :for="'garage' + key">{{ item }}</label>
                </div>
            </div>
        </div>
        <Occupation v-if="status == ''" :data.sync="data"></Occupation>
    </form>
</template>

<script>
    import Occupation from '@/components/forms/Occupation.vue'

    export default {
        props: ['status', 'data'],
        components: {
            Occupation
        },
        data () {
            return {
                daysList: {
                    11: 'Сегодня',
                    12: 'Завтра',
                },
                garageList: {
                    1: 'Авто',
                    2: 'Мото',
                },
                day: 11,
                garage: 1
            }
        },
        created () {
            this.getData()
        },
        methods: {
            getData () {
                this.$emit('getData', 'day=' + this.day + '&garage=' + this.garage)
            }
        }
    }
</script>